// @ts-nocheck
const CustomerInvoiceView = () => {
    return (
        <div>CustomerInvoiceView</div>
    )
}

export default CustomerInvoiceView